import { BrowserPermissions } from './BrowserPermissions';
import { CordovaPermissions } from './Diagnostics';
import { Observable } from 'rxjs';
import { isCordova } from 'utils/platform';

export interface LocationPermissions {
  inUse: boolean;
  gpsEnabled: boolean;
  getHighAccuracyPermission: boolean;
  background: boolean;
  canRequestBackground: boolean;
  canRequestInUse: boolean;
  canReRequest: boolean;
}

export interface Permissions {
  push: boolean;
  location: LocationPermissions;
  backgroundRefresh: boolean;
  camera: boolean;
}

export interface PermissionProvider {
  permissions$: Observable<Permissions>;

  requestLocationBackgroundPermission(): Promise<boolean>;

  requestLocationInUsePermission(): Promise<boolean>;

  permissions(): Promise<Permissions>;

  askForLocationPermissionsAfterDenial(): Promise<boolean>;
}

const provider = isCordova() ? new CordovaPermissions() : new BrowserPermissions();

export const permissions$: Observable<Permissions> = provider.permissions$.shareReplay(1);

export function requestLocationBackgroundPermission(): Promise<boolean> {
  return provider.requestLocationBackgroundPermission();
}

export function requestLocationInUsePermission(): Promise<boolean> {
  return provider.requestLocationInUsePermission();
}

export function requestHighAccuracyLocationPermission(): Promise<boolean> {
  return provider.requestHighAccuracyLocationPermission();
}

export function permissions(): Promise<Permissions> {
  return provider.permissions();
}

export function askForLocationPermissionsAfterDenial() {
  return provider.askForLocationPermissionsAfterDenial();
}
